/**
 * @generated SignedSource<<11dbbfed9a327ddac5983cd37d92a519>>
 * @relayHash c76a04f0efb197379ec3148bdabb1e59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24ab56e8e7fea324eaf211464d7582474c267a1fc0077769d24babce145cd574

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery } from './ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery.graphql';

const node: PreloadableConcreteRequest<ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "24ab56e8e7fea324eaf211464d7582474c267a1fc0077769d24babce145cd574",
    "metadata": {},
    "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
